import { Button, Card, Carousel, Col, DatePicker, Form, Input, InputNumber, Modal, Popconfirm, Row, Select, Tag } from "antd";
import { Menu } from "../../../model/menudesign/Menu";
import { PostMenus } from "../../../dao/menudesign/PostMenus";
import { BiArrowToLeft,BiRightArrowAlt , BiLeftArrowAlt   , BiArrowToRight, BiCheck, BiDish, BiFoodMenu, BiPencil, BiPlus, BiRefresh, BiTrash, BiX , BiSave } from "react-icons/bi";
import { GetMenus } from "../../../dao/menudesign/GetMenus";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import Colors from "../../../styles/Colors";
import { GetPlats } from "../../../dao/menudesign/GetPlats";
import { Plat } from "../../../model/menudesign/Plat";
import { MinusCircleOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { MenuPlat } from "../../../model/menudesign/MenuPlat";
import { AuthContext } from "../../../config/AuthContext";
import { useParams } from "react-router-dom";
import { GetMenusByWeek } from "../../../dao/menudesign/GetMenusByWeek";
import { BsEye } from "react-icons/bs";
import Table, { ColumnsType, TableProps } from "antd/es/table";
import PlantillaLista from "../../PlantillaLista";
import MenuModal from "./MenuModal";
import { GetPlatsMenuByDay } from "../../../dao/menudesign/GetPlatsMenusByDay";
import {format} from "date-fns";
import weekday from 'dayjs/plugin/weekday';
import dayjs from "dayjs";
import { GetPlatsMenu } from "../../../dao/menudesign/GetPlatsMenu";
import '../../../styles/menudesign/menu.css';
import MenuPlatModal from "./MenuPlatModal";
import PlatModal from "./PlatModal";
import { GetIngredients } from "../../../dao/menudesign/GetIngredients";
import { GetVariacio } from "../../../dao/menudesign/GetVariacio";
import Ingredient from "../../../model/menudesign/Ingredient";
import Variacio from "../../../model/menudesign/Variacio";
import { PlatIngredient } from "../../../model/menudesign/PlatIngredient";
import type { CarouselRef } from 'antd/es/carousel';
import { PostPlatsMenu } from "../../../dao/menudesign/PostPlatsMenu";
import toast, {Toaster} from "react-hot-toast";
import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isoWeek);
import { Spin, Empty } from "antd"; 


interface MenuSetmanaModalProps {
    element: Menu;
    page: string;
    setmana: string;
    diames: number;
    diasetmana: number;
    dataM: string
    visibleM: boolean;
    onClose: () => void;
}

const MenuSetmanaModal: React.FC<MenuSetmanaModalProps> = ({element, page, setmana, diames, diasetmana, dataM, visibleM, onClose}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user} = useContext(AuthContext);
    const {id} = useParams();
    const [coleccio, setDades] = useState<Menu[]>([]);
    const [coleccioMP, setDadesMP] = useState<MenuPlat[]>([]);
    const [coleccioP, setDadesP] = useState<Plat[]>([]);
    const [coleccioV, setDadesV] = useState<Variacio[]>([]);
    const [elementSelected, setElementSelected] = useState<Menu>(new Menu());
    const [elementSelectedP, setElementSelectedP] = useState<Plat>(new Plat());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nouElementP, setNouElementP] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [visibleMP, setVisibleMP] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [primerPlats, set1Plats] = useState<{ value: number; label: string; }[]>([]);
    const [segonPlats, set2Plats] = useState<{ value: number; label: string; }[]>([]);
    const [postrePlats, setPostrePlats] = useState<{ value: number; label: string; }[]>([]);
    const [complementPlats, setCompPlats] = useState<{ value: number; label: string; }[]>([]);
    const [panel, setPanel] = useState(0);
    const numPaneles = 5;
    const ref = useRef<CarouselRef>(null);
    const diesSetmana = ["Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres"];
    const [menuBasalId, setMenuBasalId] = useState<number | null>(null);
    const lunesSemana = dayjs(dataM, "DD/MM/YYYY").startOf("week"); 


    async function checkListas(){
        const dadesP = await GetPlats(page) || [];
        const primers = dadesP.filter(p => p.tipus == "Primer plat");
        const segons = dadesP.filter(p => p.tipus == "Segon plat");
        const postres = dadesP.filter(p => p.tipus == "Postre");
        const complements = dadesP.filter(p => p.tipus == "Complement");
        const primerList = primers.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        const segonList = segons.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        const postreList = postres.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        const complementList = complements.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        set1Plats(primerList);
        set2Plats(segonList);
        setPostrePlats(postreList);
        setCompPlats(complementList);
    }

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
            checkListas();
            }
        }, [id]);
    
    useLayoutEffect(() => {
        if (ref.current) {
        ref.current.goTo(diasetmana, true);
        }
    }, [ref]);
    
  useEffect(() => {
    if (diasetmana !== undefined) {
      setPanel(diasetmana); 
    }
  }, [diasetmana]);
    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetMenusByWeek(page, setmana) || [];
        const dadesP = await GetPlats(page) || [];
        const dadesMP = await GetPlatsMenu(page);
        const dadesV = await GetVariacio(page);
        setDades(dades);
        setDadesP(dadesP);
        setDadesMP(dadesMP);
        setDadesV(dadesV);
        //await setNameFilters(dades);
        await handleLoadingChange(false);
        console.log("Coleccio de menus", coleccio)
    }

    const menuBasal = coleccio.some(m => m.setmana == setmana);
    console.log("m ",menuBasal);



    function toggleTable() {
        setVisible(!visible);
    }
    
    async function deleteElement(id: number) {
        //await Deleteany(id, page);
        await checkDades();
    }

    function afegirElement(element: Menu, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }
    

    function togleNouElement(element: Menu, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }

    

     async function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        await checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function handleSubmit(values: any, diaIndex: number, menuId: number, id_variacio: number, basal: number) {
      try {
        const lunesSemana = dayjs(dataM, "DD/MM/YYYY").startOf("week"); 
        const fecha = lunesSemana.add(diaIndex, "day");

        const formData: any = { ...values };
        formData.data = fecha.format("YYYY-MM-DD");
        formData.dia = diaIndex;
        formData.setmana = fecha.format("YYYY-[W]WW");
        

        const menuplat = [
          { id_plat: formData.id_plat_1, dia: formData.dia, posicio: 0, data: formData.data },
          { id_plat: formData.id_plat_2, dia: formData.dia, posicio: 1, data: formData.data },
          { id_plat: formData.id_plat_3, dia: formData.dia, posicio: 2, data: formData.data },
          { id_plat: formData.id_plat_4, dia: formData.dia, posicio: 3, data: formData.data },
        ];

        delete formData.id_plat_1;
        delete formData.id_plat_2;
        delete formData.id_plat_3;
        delete formData.id_plat_4;

        formData.menu_plat = JSON.stringify(menuplat);
        formData.id = menuId;
        formData.id_variacio = id_variacio;
        formData.basal = basal;

        await PostMenus(formData, page);
        await checkDades();
        toast.success("Guardat correctament"); 
    } catch (error) {
        console.error(error);
        toast.error("Error al guardar"); 
    }

  }

    function getMenuBasalId(diaIndex: number): number | null {
      const basal = coleccio.find(
        (m) =>
          m.id_variacio === 0 &&                
          (m.plats ?? []).some((p) => p.dia === diaIndex)
      );
      return basal ? basal.id : 0;
    }

    async function handleCancel() {
        await onClose();
    };
    
    const onChange: TableProps<Menu>['onChange'] =
        (pagination,
            filters,
            sorter,
            extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    return (
      
        <Modal
          title="Menus de la setmana"
          open={visibleM}
          onCancel={handleCancel}
          footer={[
          ]}
            
          width={1200} 
          bodyStyle={{
          maxHeight: "100vh", 
               
            }}
            style={{ top: 50 }}
        >
            <Toaster/>
            <Spin spinning={loading}>
                <Carousel
                    arrows
                    infinite={false}
                    afterChange={(current) => setPanel(current)}
                    prevArrow={panel > 0 ? <BiLeftArrowAlt  /> : <></>}
                    nextArrow={panel < numPaneles - 1 ? <BiRightArrowAlt color="" /> : <></>}
                    ref={ref}
                    >
                    {diesSetmana.map((dia, index) => {
                      
                      const lunesSemana = dayjs(dataM, "DD/MM/YYYY").startOf("week"); 
                      const fechaDia = lunesSemana.add(index, "day");
                      const diaMes = fechaDia.format("DD/MM");
                      const menusDia = coleccio.filter((menu) =>
                        (menu.plats ?? []).some((p: any) => p.dia === index)
                      );
                      return (
                        <div key={dia}>
                        <Card bordered className="elemento">
                           
                            <div className="actionButtons">
                                <Button
                                title="Afegir Menu Basal"
                                style={{ backgroundColor: Colors.colors.color6 }}
                                onClick={() => {
                                  const basalId = getMenuBasalId(index);
                                  setNouElement(true);
                                  setEditar(true);
                                  setElementSelected(new Menu());
                                  setMenuBasalId(basalId); 
                                }}
                                >
                                <BiFoodMenu />
                                </Button>
                            {"  "}
                            <Button
                                title="Refrescar"
                                style={{ backgroundColor: Colors.colors.color4 }}
                                onClick={() => checkDades()}
                            >
                                <BiRefresh />
                            </Button>
                            </div>

                           
                            <h4 className="titol">{`Menú ${dia} (${diaMes})`}</h4>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    maxHeight: "65vh",  
                                    overflowY: "auto",   
                                    paddingRight: 8, 
                                    
                                }}
                                >
                                  {menusDia.length === 0 ? (
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />  
                                  ) : (
                            coleccio
                            .filter((menu) => (menu.plats ?? []).some((p: any) => p.dia === index))
                            .map((menu) => {
                              const platsDia = (menu.plats ?? []).filter((p: any) => p.dia === index);
                              const variacioNom = coleccioV.find((v) => v.id === menu.id_variacio)?.nom || "Basal";

                              return (
                                <div style={{ width: "90%", padding: "1%"}} key={menu.id}>
                                  <Card
                                  title={`Variació: ${variacioNom.toUpperCase()}`}
                                  style={{ width: "100%", backgroundColor: "#dbe4d368", border: "0.2px solid #9d9b9b72", }}
                                  extra={<span style={{ fontWeight: "bold" }}>ID: {menu.id}</span>}
                                  bordered
                                   headStyle={{
                                      backgroundColor: "#dbe4d362", 
                                      color: "#000",             
                                      fontWeight: "bold",
                                    }}
                                >
                                  <Form
                                    layout="vertical"
                                    initialValues={{
                                      id_plat_1: platsDia.find((p: any) => p.posicio === 0)?.id_plat,
                                      id_plat_2: platsDia.find((p: any) => p.posicio === 1)?.id_plat,
                                      id_plat_3: platsDia.find((p: any) => p.posicio === 2)?.id_plat,
                                      id_plat_4: platsDia.find((p: any) => p.posicio === 3)?.id_plat,
                                    }}
                                    onFinish={(values) => handleSubmit(values, index, menu.id, menu.id_variacio, menu.basal)}
                                  >
                                    <Row gutter={8}>
                                      <Col span={12}>
                                        <Form.Item
                                          label="Primer Plat"
                                          name="id_plat_1"
                                          rules={[{ required: true, message: "Aquest camp es obligatori" }]}
                                        >
                                          <Select showSearch optionFilterProp="label" options={primerPlats} />
                                        </Form.Item>
                                      </Col>
                                      <Col span={12}>
                                        <Form.Item
                                          label="Segon Plat"
                                          name="id_plat_2"
                                          rules={[{ required: true, message: "Aquest camp es obligatori" }]}
                                        >
                                          <Select showSearch optionFilterProp="label" options={segonPlats} />
                                        </Form.Item>
                                      </Col>
                                    </Row>
                                    <Row gutter={8}>
                                      <Col span={12}>
                                        <Form.Item
                                          label="Complement"
                                          name="id_plat_3"
                                          
                                        >
                                          <Select showSearch optionFilterProp="label" options={complementPlats} allowClear/>
                                        </Form.Item>
                                      </Col>
                                      <Col span={12}>
                                        <Form.Item
                                          label="Postre"
                                          name="id_plat_4"
                                          rules={[{ required: true, message: "Aquest camp es obligatori" }]}
                                        >
                                          <Select showSearch optionFilterProp="label" options={postrePlats} />
                                        </Form.Item>
                                      </Col>
                                    </Row>

                                    
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      style={{ backgroundColor: Colors.colors.color5 }}
                                    >
                                      <BiSave />
                                    </Button>
                                  </Form>
                                </Card>

                                </div>
                            );
                    })
                  )}

                            </div>
                        </Card>
                        </div>
                   );
                  })}

                    
                    {nouElement && (
                        <MenuModal
                        element={elementSelected}
                        onClose={handleCloseModal}
                        visible={nouElement}
                        editar={editar}
                        setmana={setmana}
                        page={page}
                        dataM={dayjs(dataM, "DD/MM/YYYY")
                            .startOf("week")
                            .add(panel, "day")
                            .format("YYYY-MM-DD")}                          
                        idBasal={menuBasalId} 
                        />
                    )}
                    
                    </Carousel>
                  </Spin>
        
        </Modal>
    )
};
export default MenuSetmanaModal;